var _ = require('lodash');
var dd = require('../lib/dd');
var esUtils = require('../utils/esUtils');
var dateformat = require('../lib/dateformat');

module.exports = dd.createClass({
	render: function(){
		var style = this.props.style || {};

		var str = buildDateRangeString(this.props.start, this.props.stop, this.props.start_format, this.props.stop_format, this.props.show_times);
		return dd.span(esUtils.isBlank(str) ? null : {className: 'DateRange', style: style}, str);
	}
});

var buildDateRangeString = function(start, stop, start_format, stop_format, show_times){
	start_format = start_format || 'ddd, mmm d, yyyy';
	stop_format = stop_format || 'mmm d';
	show_times = !!show_times;
	var str_parts = [];
	if(_.isDate(start)){
		str_parts.push(dateformat(start, start_format));
	}
	if(show_times){
		str_parts.push(timeOrBlakIfMidnight(start));
	}
	if(_.isDate(start) && _.isDate(stop)){
		var show_end_date = parseInt(start.getTime() / (1000 * 60 * 60 * 24)) !== parseInt(stop.getTime() / (1000 * 60 * 60 * 24));
		var show_end_time = show_times && (show_end_date || timeOrBlakIfMidnight(start) != timeOrBlakIfMidnight(stop));

		if(show_end_date || show_end_time){
			str_parts.push("to");
		}
		if(show_end_date){
			str_parts.push(dateformat(stop, stop_format));
		}
		if(show_end_time){
			str_parts.push(timeOrBlakIfMidnight(stop));
		}
	}
	return str_parts.join(" ");
};

var timeOrBlakIfMidnight = function(d){
	var time = dateformat(d, 'h:MM TT');
	return time === '12:00 AM' ? '' : time;
};

module.exports.__for_testing__ = {
	buildDateRangeString: buildDateRangeString
};



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/DateRange.js
// module id = 65
// module chunks = 0 1 2 3 4